var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyAssignedjobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-empty-assignedjobs",
    transform: "translate(-310 -302)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(310 302)",
    fill: "#1a1b43",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3718",
    "data-name": "Group 3718",
    transform: "translate(340 332)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1487",
    "data-name": "Rectangle 1487",
    width: 60,
    height: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3719",
    "data-name": "Group 3719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M16.518,11.3A2,2,0,0,0,13.236,12L.13,46.582A2,2,0,0,0,2,49.29a1.962,1.962,0,0,0,.786-.162L36.148,34.82a2,2,0,0,0,.628-3.252Zm2.22,26.638-4.886-4.89a2,2,0,0,0-2.826,2.828l3.756,3.76L5.534,43.6,12.55,25.088,20.558,33.1a2,2,0,0,0,2.826-2.828l-9.278-9.286,1.772-4.676,15.982,16Z",
    transform: "translate(0 10.71)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M11.274,17.38a2,2,0,0,0,1.64-.852c.19-.276,4.646-6.77.662-12.148a2,2,0,0,0-3.214,2.382c2.266,3.058-.7,7.432-.728,7.476a2,2,0,0,0,1.64,3.142Z",
    transform: "translate(9.276 3.57)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M12.018,25.22a2,2,0,0,0,2.562,1.2l4.128-1.5A2,2,0,0,0,19.9,22.348l-.818-2.25,2.248-.82a2,2,0,0,0,1.2-2.564l-.818-2.25,2.248-.818a2,2,0,0,0,1.194-2.566l-.818-2.25,2.248-.818a2,2,0,0,0,1.2-2.564l-1.5-4.132a2,2,0,1,0-3.754,1.37l.818,2.25-2.25.818A2,2,0,0,0,19.894,8.32l.818,2.25-2.248.818a2,2,0,0,0-1.194,2.564l.816,2.252-2.248.818a2,2,0,0,0-1.194,2.564l.818,2.252-2.248.818A2,2,0,0,0,12.018,25.22Z",
    transform: "translate(11.896 0)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M41.943,11.693l-4.128-1.5a2,2,0,0,0-2.56,1.2l-.818,2.25-2.252-.818a2,2,0,0,0-2.56,1.194l-.82,2.252-2.25-.82a2,2,0,0,0-2.56,1.2l-.818,2.252-2.25-.818a2,2,0,0,0-2.562,1.194l-1.5,4.13a2,2,0,1,0,3.754,1.366l.82-2.25,2.25.818a1.994,1.994,0,0,0,2.562-1.194l.818-2.25,2.25.818a2,2,0,0,0,2.56-1.2l.82-2.25,2.25.818a1.959,1.959,0,0,0,1.528-.066,1.991,1.991,0,0,0,1.034-1.128l.818-2.25,2.25.818a2,2,0,0,0,1.366-3.758Z",
    transform: "translate(16.741 10.069)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M20.363,20.055a2,2,0,0,0,2.286,3.28c.044-.026,4.424-2.986,7.472-.728A2,2,0,0,0,32.5,19.4C27.127,15.4,20.637,19.863,20.363,20.055Z",
    transform: "translate(19.513 17.741)",
    fill: "#1a1b43"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M7.333,9.917a2,2,0,1,1-2-2A2,2,0,0,1,7.333,9.917Z",
    transform: "translate(3.333 7.917)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(41.208 11.268)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(43.924 45.189)",
    fill: "#1a1b43"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyAssignedjobs);
export default __webpack_public_path__ + "static/media/icon-empty-assignedjobs.8a1cc1462ebcfe88656008ca02c1e44a.svg";
export { ForwardRef as ReactComponent };